<template>
  <div
      class="block space-y-4 w-screen px-4 md:w-full "
  >

      <div>
        <input
            type="text"
            v-model="refEngraving.text"
            ref="textInput"
            @keyup="$emit('update:engraving', engraving);$emit('switch:image', 'Engraving')"
            @change="$emit('patch', {action: 'engraving.inside.text', value: refEngraving.text.trim(), certificated_diamond: true})"
            class="text-base block w-full bg-white p-2  border border-brand-main"
            :style="{fontFamily: refEngraving.font}"
        />
      </div>
      <div class="flex w-full">
        <div class="w-1/3 flex cursor-pointer" @click="showSymbols = !showSymbols; showFonts = false">
          <div class="">
            <span class="block text-black pr-1 text-xs" :class="{'font-bold': showSymbols}">{{ t(pageStr + '.symbols') }}</span>
          </div>
          <div class="flex-shrink-0 w-4">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4 transition-transform duration-300"
                :class="{ 'rotate-180': showSymbols }"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>
        <div class="w-2/3 flex cursor-pointer" @click="showFonts = !showFonts; showSymbols = false">
          <div class="flex-grow text-right">
            <span class="block text-black pr-1 text-xs overflow-hidden whitespace-nowrap"
                  :class="{'font-bold': showFonts}">{{ t(pageStr + '.font') }} {{ engravingFonts[engraving.font.toString()] }}</span>
          </div>
          <div class="w-4">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4 transition-transform duration-300"
                :class="{ 'rotate-180': showFonts }"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>
      </div>
      <div v-if="showFonts">
        <ul class="text-sm divide-y divide-y-brand-main">
          <li
              v-for="(font, fontIdx) in engravingFonts"
              :key="fontIdx"
              class="flex cursor-pointer py-2 hover:bg-gray-100"
              @click="selectFont(fontIdx)">
            <span class="flex-1">{{ font }}</span>
            <span class="flex-1  overflow-hidden whitespace-nowrap" :class="fontIdx"
                  :style="{fontFamily: fontIdx}">{{ refEngraving.text }}</span>

          </li>
        </ul>
      </div>
      <div v-if="showSymbols">
        <ul class="text-sm grid gap-2 grid-cols-6">
          <li
              v-for="(symbole, symboleIdx) in engravingSymbols"
              :key="symboleIdx"
              class="cursor-pointer p-4 hover:bg-gray-100 text-center flex items-center justify-center"
              @click="addSymbole(symboleIdx as string)">
            <img :src="require('@/assets/img/symbols/' + symboleIdx.toString() + '.png')" :alt="symboleIdx.toString()"/>


          </li>
        </ul>
      </div>
  </div>
</template>
<script setup lang="ts">
import {ref} from "vue";
import {useI18n} from "vue-i18n";

const props = defineProps(["engraving"]);
const emit = defineEmits(['update:engraving', 'patch', 'switch:image'])

const {t} = useI18n();
const showFonts = ref(false);
const showSymbols = ref(false);
const textInput = ref<HTMLElement[] | null>(null);
const pageStr = "components.itemV2.itemV2Engraving"

const engravingFonts = {
  "Amsterdam": "Amsterdam",
  "Arial": "Arial",
  "AvantGarde": "Avant Garde",
  "Benguiat": "Benguiat",
  "Berlin": "Berlin",
  "BoereTudor": "Boere Tudor",
  "EdwardianScriptITC": "Edwardian Script ITC (ID: 10)",
  "EnglischeSchT": "Englische SchT (ID: 3)",
  "English111VivaceBT": "English 111 Vivace BT (ID: 11)",
  "FreestyleScript": "Freestyle Script (ID: 16)",
  "PalaceScript": "Palace Script (ID: 4)",
  "Genf": "Genf",
  "Italic": "Italic",
  "Koeln": "Koeln",
  "LegerD": "LegerD (ID: 15)",
  "MonotypeCorsiva": "Monotype Corsiva (ID: 14)",
  "NuptialBT": "Nuptial BT",
  "Oslo": "Oslo",
  "PalatinoLinotype": "Palatino Linotype (ID: 62)",
  "Paris": "Paris",
  "ScriptMTBold": "Script MT Bold",
  "SloganD": "SloganD",
  "TimesNewRoman": "Times New Roman (ID: 2)",
  "Vivaldi": "Vivaldi (ID: 13)"
}

const engravingSymbols: { [key: string]: string } = {
  // a_Herz.dxf
  "heart": "Ⓐ",
  // b_Doppelherz.dxf
  "doubleHeart": "Ⓒ",
  // c_Doppelherz-m-Pfeil.dxf
  "doubleHeartArrow": "Ⓑ",
  // d_Herz-m-Pfreil.dxf
  "heartArrow": "Ⓓ",
  // e_Doppelringe.dxf
  "doubleRings": "Ⓘ",
  // f_Taube.dxf
  "pigeon": "Ⓙ",
  // g_Infinity-Zeichen.dxf
  "infinity": "Ⓕ",
  // h_Herzschloss.dxf
  "heartCastle": "Ⓚ",
  // i_Anker.dxf
  "anchor": "Ⓝ",
  // j_Glaube-Liebe-Hoffnung.dxf
  //"faith": "Ⓔ",
  // k_Amors-Bogen.dxf
  "amorArrow": "Ⓖ",
  // l_Amor.dxf
  "amor": "Ⓗ",
  // m_Krone.dxf
  "crown": "Ⓛ",
  // n_Kutsche.dxf
  //"carriage": "Ⓞ"
}

const addSymbole = (symboleIdx: string) => {
  const pos = textInput.value?.selectionStart || 0
  const symbole = engravingSymbols[symboleIdx]

  refEngraving.value.text = refEngraving.value.text.slice(0, pos) + " " + symbole + " " + refEngraving.value.text.slice(pos);

  refEngraving.value.text = refEngraving.value.text.replace(/ +(?= )/g, '')

  updateFont()

  emit('patch', {
    action: 'engraving.inside.text',
    value: refEngraving.value.text,
    certificated_diamond: true
  });

}

const refEngraving = ref(props.engraving);

const selectFont = (fontId: string) => {
  refEngraving.value.font = fontId;

  updateFont()

  emit('patch', {
    action: 'engraving.inside.font',
    value: refEngraving.value.font,
    certificated_diamond: true
  });
}

const updateFont = () => {
  refEngraving.value.text = refEngraving.value.text.trim()

  emit('update:engraving', refEngraving.value);
  emit('switch:image', 'Engraving')
}

</script>
